<template>
  <div class="d-flex justify-content-center">
    <FloatingSquares />
    <form @submit.prevent="doLogin">
      <el-card class="login-card mt-5">
        <b-row class="mb-3">
          <b-col sm="12">
            <img src="@/assets/images/CI/Viacor_Claim_pos_silver_RGB.png" class="m-3 login-logo" />
            <hr />
            <b>{{ $t('general.enter_credentials') }}</b>
            <el-input v-model="user.email" class="mt-1" :placeholder="$t('general.email')" type="email">
              <i slot="prefix" class="el-input__icon el-icon-user" />
            </el-input>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col sm="12">
            <el-input
              v-model="user.password"
              :placeholder="$t('general.password')"
              show-password
              autocapitalize="none"
              autocorrect="off"
            >
              <i slot="prefix" class="el-input__icon el-icon-lock" />
            </el-input>
            <el-link @click="$router.push('/forgot-password')">
              {{ $t('general.forgot_password') }}
            </el-link>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col sm="12">
            <button class="el-button el-button--primary mt-1" type="submit">
              {{ $t('general.login') }}
            </button>
            <br />
            <br />
          </b-col>
        </b-row>
        <el-link @click="$router.push('/register')">
          {{ $t('general.not_registered_yet') }}
        </el-link>
      </el-card>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import FloatingSquares from '../components/backgrounds/FloatingSquares';
import StoreModules from '../store/store-modules';
export default {
  name: 'LoginPage',
  components: { FloatingSquares },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
    };
  },
  computed: {
    loginButtonEnabled() {
      return this.user.email.length > 0 && this.user.password.length >= 6;
    },
  },
  methods: {
    ...mapActions(StoreModules.USER, ['login']),
    async doLogin() {
      try {
        await this.login(this.user);
        this.$router.push({ name: this.$routeNames.MAIN_PAGE_ROUTE });
      } catch (e) {
        this.$message.error(this.$t('general.login_failed'));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-background {
  background: url('../assets/images/Backgrounds/StockSnap_UHBNCUKSFS.jpg');
  background-size: cover;
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
}
.login-card {
  max-width: 600px;
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.3) !important;
  backdrop-filter: blur(15px);
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
  border-top: 0 !important;
  width: 95%;
}
.login-logo {
  max-width: 300px;
  margin: 0 auto;
}
</style>
